import { render } from "./AddressList.vue?vue&type=template&id=d4da2320&scoped=true"
import script from "./AddressList.vue?vue&type=script&lang=js"
export * from "./AddressList.vue?vue&type=script&lang=js"

import "./AddressList.vue?vue&type=style&index=0&id=d4da2320&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4da2320"]])

export default __exports__